import Layout from "@/layout/index.vue";
const newsManager = {
    path: '/feedback',
    component: Layout,
    redirect: 'noRedirect',
    name: 'feedbackManager',
    meta: {
        title: '',
        icon: 'DocumentCopy'
    },
    children: [
        {
            path: 'list',
            component: () => import('@/views/feedback/index.vue'),
            name: 'list',
            meta: { title: '留言管理', noCache: true,icon: 'DocumentCopy'  }
        },
    ]

}

export default newsManager
